module.exports = __webpack_public_path__ + "img/share.b1118c29.svg";